import { BaseBus } from "./BaseBus";
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from "../static/common-functions";

 export class ScheduleInvoiceBus extends BaseBus
 { 
     constructor(busObj: ScheduleInvoiceBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
         this.startDate = DateFunctions.getDate(this.startDate);
     }
     CID(): any {
         return this.scheduleInvoiceId;
     }
     setId(id: any) {
         this.scheduleInvoiceId = id;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
         if (!CommonFunctions.hasGuidValue(this.companyId)) {
             this.companyId = companyId;
         }
     }
     setBeforeSave() {
         this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
         this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
         this.startDate = DateFunctions.getDateWithUTCOffset(this.startDate);
     }
     scheduleInvoiceId: any;
     companyId: any;
     invoiceId: any;
     unschedule: boolean;
     startDate: Date;
     scheduleFrequencyId: any;
     scheduleName: string;
     insertDt: Date;
     insertUserId: any;
     updateDt: Date;
     updateUserId: any;
     customerName: string;
     locationName: string;
     invoiceNumber: string;
     everyXMonths: number;
 }
